export default "__VITE_ASSET__CmMqc4YE__"